import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ContentsquareService } from '@app/services/contentsquare/contentsquare';
import { EnvironmentService } from '@app/services/environment/environment.service';
import { UsercentricsService } from '@app/services/usercentrics/usercentrics';

@Component({
  selector: 'bingo-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly gtmService = inject(GoogleTagManagerService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly usercentricsService = inject(UsercentricsService);
  private readonly environmentService = inject(EnvironmentService);
  private readonly contentsquareService = inject(ContentsquareService);
  protected readonly title = signal('match15');

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.usercentricsService.init();
      this.contentsquareService.init();

      /* Advanced Consent Mode: GTM loads right away and brings the Usercentrics CMP with it (template
         on the Consent Initialization trigger). Consent defaults (all denied) are set in index.html
         before this; tags inside GTM wait for the consent update. Listen to the CMP first (above). */
      if (this.environmentService.gtmId) {
        void this.gtmService.addGtmToDom();
      }
    }
  }
}
